import React from 'react'
import cn from 'classnames'

import Box from './Box'
import styles from './SelectedWork.module.css'

export default () => (
  <div className={cn(styles.container, 'reveal')} id="clientsContainer">
      <h4>Selected Work</h4>
    <div className={styles.boxes}>
      <Box
        title="Stockholm Commuting"
        subtitle="Res i Sthlm"
        tintColor="#e0e5ee"
        textColor="#151f28"
        height="380"
        link="https://itunes.apple.com/se/app/res-i-sthlm-sl-reseplanerare/id296171628?mt=8"
        image={require('../images/case-ris@2x.png')}
      />
      <Box
        title="Coaching App"
        subtitle="Supercoach"
        tintColor="#151f28"
        height="380"
        textColor="#b0d4f1"
        link="https://itunes.apple.com/se/app/supercoach-soccer/id1004137166?l=en&mt=8"
        image={require('../images/case-super-coach@2x.png')}
      />
      <Box
        title="Commuter App"
        subtitle="Travis"
        tintColor="#001e44"
        height="380"
        textColor="#b0d4f1"
        link="https://itunes.apple.com/se/app/travis/id1219489195?mt=8"
        image={require('../images/case-travis-1@2x.png')}
      />
      <Box
        title="3D Illustrations"
        subtitle="Travis"
        tintColor="#001e44"
        height="260"
        textColor="#b0d4f1"
        link="https://dribbble.com/shots/4012616-Onboarding-Animation-Travis"
        image={require('../images/case-travis-2@2x.png')}
      />
      <Box
        title="Investment App"
        subtitle="Fundler"
        tintColor="#12b3b3"
        height="300"
        textColor="#ffffff"
        link="https://itunes.apple.com/se/app/fundler/id1235645990?l=en&mt=8"
        image={require('../images/case-primepilot@2x.png')}
      />

    </div>
  </div>
)



// WEBPACK FOOTER //
// ./src/components/SelectedWork.js